import React from "react";

import { hunCounties, hunCountryCode } from "lib/build/concepts";

import { Input } from "src/common/components/Input";
import { Select } from "src/common/components/Select";

const options = hunCounties.map(value => ({ value, label: value }));

type CountySelectProps = Omit<
	React.ComponentProps<typeof Select>,
	"options"
> & {
	country?: string;
};

export const CountySelect: React.FunctionComponent<CountySelectProps> = ({
	country,
	...props
}) =>
	country === hunCountryCode ? (
		<Select {...props} options={options} />
	) : (
		<Input {...props} type="text" />
	);
